import {
  type ModalProperties,
  type ModalScreen,
  toModalProperties
} from '~/utils/modalProperties';

import ImpressionEvent, { type ImpressionType } from './ImpressionEvent';

type EventData = {
  guestId?: string;
  isBot: boolean;
  screen: ModalScreen;
};

// A modal is an overlay and sends no view of its own, so a screen shown is an impression on the
// page underneath it. The taps on that screen carry the same three fields and join it on them.
class ModalImpressionEvent extends ImpressionEvent<EventData, ModalProperties> {
  protected get impressionType(): ImpressionType {
    return 'modal';
  }

  protected getImpressionProperties(): ModalProperties {
    return toModalProperties(this.data.screen);
  }
}

export default ModalImpressionEvent;
